import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Loader } from '../../../components/Loader';
import { HBox, VBox } from '../../../components/Box';
import { Card } from '../../../components/Card';
import { List, Row } from '../../../components/List';
import { Edit, Times } from '../../../components/Icon';
import { setUserProperty } from '../actions';
import { fetchUser } from '../../Users/actions';
import { selectWorks } from '../../Api/selectors';
import { selectUser } from '../../Users/selectors';
import { getPropByName } from '../../../utils/props';
import { REQUEST_USER } from '../../Users/constants';
import { REQUEST_USER_PROPERTY_UPDATE } from '../constants';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { Textarea } from '../../../components/Textarea';
import ModalComponent from '../../../containers/App/Components/Modal/Modal';
import ButtonComponent from '../../../containers/App/Components/Button/Button';
import env from '../../../env';
import { AppClientId } from '../../Shared/constants';
import cn from 'classnames';
import styles from './CardUserRemarks.module.css';
import { Label } from '../../Vehicles/components/VehicleCounterLabel';

dayjs.extend(customParseFormat);

// Styled Components
const Container = styled.div`
  font-size: 14px;
  align-items: center;

  .icon-block {
    cursor: pointer;
    font-size: 22px;
  }

  .icon-cross {
    cursor: pointer;
    font-size: 22px;
    width: 20px;
    height: 22px;
  }

  .disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .icon-edit-square {
    color: #0183d5;
  }

  .fa-square-xmark {
    padding: 0 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20px;
    height: 20px;
    background-color: #d50046;
    color: #fff;
  }

  .remark {
    margin-bottom: 10px;
    min-height: 60px;

    .initials-wrapper {
      width: 40px;
      height: 40px;
      background-color: rgba(29, 155, 209, 0.1);
      justify-content: center;
      border-radius: 50%;
    }

    .text {
      width: 85%;
      text-align: start;
    }
  }

  .text-input {
    width: 100%;
    resize: none;
  }
`;

const STATE = {
  isOpenAddModal: false,
  attRemarks: [],
  newRemarkText: '',
  editableRemark: null,
};

const ranges = {
  '#00BFAE': [1, 3],
  DarkOrange: [4, 6],
  Crimson: [7, Infinity],
};

class UserAttRemarksCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
    this.handleSave = this.handleSave.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleReset = this.handleReset.bind(this);
    this.handleModalOpen = this.handleModalOpen.bind(this);
  }

  componentDidMount() {
    const { user, fetch } = this.props;
    if (user?.attRemarks) {
      this.setState({ attRemarks: JSON.parse(user.attRemarks) });
    }
    fetch();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.user?.attRemarks !== this.props.user?.attRemarks) {
      this.setState({ attRemarks: JSON.parse(this.props.user?.attRemarks) });
    }
  }

  get remarkDate() {
    return dayjs(new Date(Date.now())).format('DD-MM-YYYY HH:mm');
  }

  get sortingDate() {
    return new Date(Date.now());
  }

  handleModalOpen(remark = null) {
    this.setState({
      isOpenAddModal: true,
      editableRemark: remark?.id || null,
      newRemarkText: remark?.text || '',
    });
  }

  handleReset() {
    this.setState({
      isOpenAddModal: false,
      editableRemark: null,
      newRemarkText: '',
    });
  }

  handleSave() {
    const { loggedUser, setRemark } = this.props;
    const { newRemarkText, attRemarks } = this.state;

    const remark = {
      id: Date.now(),
      userId: loggedUser?.id,
      text: newRemarkText,
      name: getPropByName(loggedUser, 'name'),
      surname: getPropByName(loggedUser, 'surname'),
      date: this.remarkDate,
      sortingDate: this.sortingDate,
    };

    const updatedRemarks = [...attRemarks, remark];

    setRemark(JSON.stringify(updatedRemarks), result => {
      if (result) {
        this.handleReset();
      }
    });
  }

  handleEdit(remarkId) {
    const { loggedUser, setRemark } = this.props;
    const { newRemarkText, attRemarks } = this.state;

    const remark = {
      id: remarkId,
      userId: loggedUser?.id,
      text: newRemarkText,
      name: getPropByName(loggedUser, 'name'),
      surname: getPropByName(loggedUser, 'surname'),
      date: this.remarkDate,
      sortingDate: this.sortingDate,
    };

    const filteredRemarks = attRemarks.filter(r => r?.id !== remarkId);
    const updatedRemarks = [...filteredRemarks, remark];

    setRemark(JSON.stringify(updatedRemarks));
    this.handleReset();
  }

  handleDelete(remarkId) {
    const { setRemark } = this.props;
    const { attRemarks } = this.state;

    const updatedRemarks = attRemarks.filter(remark => remark?.id !== remarkId);
    setRemark(JSON.stringify(updatedRemarks));
  }

  renderInitials(name, surname) {
    return (
      <HBox left vCenter>
        <HBox className="initials-wrapper" vCenter left>
          <strong>{name[0]?.toUpperCase()}</strong>
          <strong>{surname[0]?.toUpperCase()}</strong>
        </HBox>
        &nbsp;
        <strong>{name ?? ''}</strong>
        &nbsp;
        <strong>{surname ?? ''}</strong>
      </HBox>
    );
  }

  renderAddModal() {
    const { editableRemark, newRemarkText } = this.state;
    const { work } = this.props;

    return (
      <ModalComponent
        title={editableRemark ? this.lbl('info.attremarks.edit') : this.lbl('info.attremarks.add')}
        onClose={this.handleReset}
      >
        <Textarea
          className="text-input"
          value={newRemarkText}
          onChange={e => this.setState({ newRemarkText: e.target?.value })}
        />

        <div className="d-flex justify-content-end gap-2 mt-3">
          <ButtonComponent
            disabled={work}
            style={'ButtonSoftEdit'}
            onClick={editableRemark ? () => this.handleEdit(editableRemark) : this.handleSave}
          >
            {editableRemark ? this.lbl('confirm') : this.lbl('add')}
          </ButtonComponent>
          <ButtonComponent style={'ButtonSoftDelete'} onClick={this.handleReset}>
            {this.lbl('cancel')}
          </ButtonComponent>
        </div>
      </ModalComponent>
    );
  }

  renderRemark(remark) {
    const { loggedUser } = this.props;
    const nl2br = text => ({ __html: text?.replace(/(?:\r\n|\r|\n)/g, '<br>') });

    return (
      <Row key={remark?.id}>
        <div className={styles.remarkCard}>
          <HBox className="gap-2" vCenter right>
            <ButtonComponent
              style={'ButtonSoftEdit'}
              disabled={env.clientId === AppClientId.HOOIKAMMER && remark?.userId !== this.props.loggedUser?.id}
              size={'btn-sm'}
              onClick={() => {
                if (env.clientId === AppClientId.HOOIKAMMER && remark?.userId !== this.props.loggedUser?.id) {
                  return;
                }
                this.handleModalOpen(remark);
              }}
            >
              <Edit />
            </ButtonComponent>

            <ButtonComponent
              style={'ButtonSoftDelete'}
              disabled={env.clientId === AppClientId.HOOIKAMMER && remark?.userId !== this.props.loggedUser?.id}
              size={'btn-sm'}
              onClick={() => {
                if (env.clientId === AppClientId.HOOIKAMMER && remark?.userId !== this.props.loggedUser?.id) {
                  return;
                }
                this.handleDelete(remark?.id);
              }}
            >
              <Times />
            </ButtonComponent>
          </HBox>
          <VBox className="remark" vCenter>
            {remark?.name && remark?.surname && this.renderInitials(remark?.name, remark?.surname)}
            <div className={styles.remarkText}>
              <pre>
                <h6 className="text" style={{ color: 'red' }} dangerouslySetInnerHTML={nl2br(remark?.text)} />
              </pre>
            </div>
          </VBox>
          <HBox right>{remark?.date}</HBox>
        </div>
      </Row>
    );
  }

  render() {
    const { work } = this.props;
    const { isOpenAddModal, attRemarks } = this.state;

    if (work) return <Loader small />;

    return (
      <Card className={cn('vehicle-info-card info-card data', styles.card)}>
        <Container>
          {isOpenAddModal && this.renderAddModal()}
          <HBox>
            <h2 className="card-title mb-0 text-muted">{this.lbl('info.attremarks.title')}</h2>
            <Label count="2" ranges={ranges}>
              {' '}
              {this.state.attRemarks ? this.state.attRemarks.length : 0}
            </Label>
          </HBox>
          <HBox vCenter right style={{ margin: '10px' }}>
            <ButtonComponent style={'ButtonSoftPrimary'} size={'btn-sm'} onClick={() => this.handleModalOpen()}>
              {this.lbl('info.remarks.add')}
            </ButtonComponent>
          </HBox>
          <List>
            {attRemarks
              ?.sort((a, b) => ((b?.sortingDate ?? b.date) < (a?.sortingDate ?? a.date) ? -1 : 1))
              ?.map(remark => this.renderRemark(remark))}
          </List>
        </Container>
      </Card>
    );
  }
}

UserAttRemarksCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
  work: PropTypes.bool,
  loggedUser: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    surname: PropTypes.string,
  }),
  user: PropTypes.shape({
    id: PropTypes.string,
    attRemarks: PropTypes.string,
  }),
  fetch: PropTypes.func.isRequired,
  setRemark: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([REQUEST_USER, `${REQUEST_USER_PROPERTY_UPDATE}-attRemarks`, REQUEST_USER_PROPERTY_UPDATE]),
    loggedUser: selectUser(ownProps?.loggedUserId),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch() {
      dispatch(
        fetchUser(ownProps?.loggedUserId, () => {}, {
          remarkCard: true,
        }),
      );
    },
    setRemark(dto, callback) {
      dispatch(setUserProperty(ownProps?.user?.id, 'attRemarks', dto, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const UserAttRemarksCard = compose(withConnect, withRouter)(UserAttRemarksCardComp);
